import { Route } from 'react-router-dom';

import { SettingsAutomationsView } from './settingsAutomations.view';
import { SettingsAutomationsAuditLogView } from './views/auditLog';
import { SettingsAutomationsEditFlowView } from './views/editFlow';

export const settingsAutomationsRoutes = (
  <Route path="automations">
    <Route path="" element={<SettingsAutomationsView />} />
    <Route
      path="flow/:automationId"
      element={<SettingsAutomationsEditFlowView />}
    />
    <Route
      path="flow/:automationId/history"
      element={<SettingsAutomationsAuditLogView />}
    />
  </Route>
);
